export default {
  registerForCredit: {
    collapseTitle: {
      baseTitle: '收证登记',
    },
    btnList: {
      save: '保存',
      submit: '确认登记',
    },
    msg: {
      saveSussess: '保存成功！',
      submitSusscess: '登记成功！',
    },
  },
};
